import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32e5b35f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labels" }, "Add demographics, interests, or behaviours", -1))
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Exclude People ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Narrow Aduience ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labels" }, "Exclude people who match at least ONE of the following", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labels" }, "MUST ALSO match at least ONE of the following", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_targeting = _resolveComponent("add-targeting")!
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_add_targeting, {
      id: "addMainTarget",
      targetingFocus: "includes",
      onAdd: _ctx.addTargeting
    }, {
      info: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onAdd"]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_default_button, {
        onActivate: _ctx.showHideExclude,
        disabled: !_ctx.profileIncludesTargeting,
        class: "exclude"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onActivate", "disabled"]),
      _createVNode(_component_default_button, {
        onActivate: _ctx.showHideNarrow,
        disabled: !_ctx.profileIncludesTargeting,
        class: "narrow"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onActivate", "disabled"])
    ]),
    (_ctx.excludeIsOpen)
      ? (_openBlock(), _createBlock(_component_add_targeting, {
          key: 0,
          id: "excludeTarget",
          targetingFocus: "excludes",
          onAdd: _ctx.addTargeting
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onAdd"]))
      : _createCommentVNode("", true),
    (_ctx.narrowIsOpen)
      ? (_openBlock(), _createBlock(_component_add_targeting, {
          key: 1,
          id: "includeTarget",
          targetingFocus: "includes",
          onAdd: _ctx.addTargeting
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onAdd"]))
      : _createCommentVNode("", true)
  ]))
}